<template>
    <div class="container">
        <div class="logo">
            <img src="../../../../public/images/ds-logo.png" alt="Цифровые Сервисы">
        </div>

        <div class="main-section">
            <div class="info-section">
                <div class="info-section__top">
                    <h1>Сервис доступен по новой ссылке</h1>
                    <div class="info">
                        <span class="primary-text">Мы перенесли сервис на новый адрес
                            <a href="https://docs.d-services.ru/docs">https://docs.d-services.ru</a>
                        </span>

                        <span class="primary-text">Пожалуйста, перейдите по кнопке ниже, чтобы продолжить работу</span>

                        <a class="btn-primary btn btn-redirect"
                            :href="targetUrl">Перейти в Бересту
                        </a>


                    </div>
                </div>

                <div class="info-section__bottom">
                    <div class="instructions">
                        <span class="secondary-text">Что делать, чтобы больше не сталкиваться с этой страницей?</span>

                        <ol class="secondary-text">
                            <li>Нажмите на кнопку "Перейти в Бересту"</li>
                            <li>Дождитесь перехода</li>
                            <li>Добавьте страницу в закладки</li>
                            <li>Или скопируйте адресную строку и запишите</li>
                        </ol>

                        <span class="secondary-text">Если нужна помощь, обратитесь к администратору:
                            <a href="mailto:support@d-services.ru?subject=Новый домен Береста">support@d-services.ru</a>
                        </span>
                    </div>
                </div>
            </div>

            <div class="img-section">
                <img src="../../../../public/images/redirectMonitor.png">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RedirectPage",

    props: {
        targetUrl: String,
    },

    data: function () {
        console.log(this.targetUrl);
    }
}
</script>

<style lang="scss" scoped>
    h1 {
        font-weight: 700;
        font-size: clamp(24px, 3vw, 40px);
        margin-bottom: clamp(20px, 4vh, 44px);
    }

    a {
        text-decoration: none;
    }

    ol {
        margin-top: 4px;
        padding-left: 1rem;
    }

    .container {
        padding: 100px 40px;
        min-height: 80vh;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;

        @media (max-width: 1500px) {
            padding: 60px 30px;
        }

        @media (max-width: 1400px), (max-height: 900px) {
            padding: 40px 20px;
        }

        @media (max-width: 1200px), (max-height: 900px) {
            padding: 0px;
        }
    }

    .logo {
        max-width: 258px;
        height: auto;
        flex-shrink: 0;

        img {
            width: 100%;
            height: auto;
        }

        @media (max-width: 768px) {
            align-self: center;
        }
    }

    .main-section {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1;
        gap: clamp(20px, 4vw, 60px);
        min-height: 0;

        @media (max-width: 900px) {
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
        }
    }

    .info-section {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-self: flex-end;
        gap: clamp(30px, 8vh, 100px);
        flex: 1;
        min-height: 0;

        &__top {
            .info {
                display: flex;
                flex-direction: column;
                gap: clamp(10px, 2vh, 16px);
            }
        }

        &__bottom {
            .instructions {
                display: flex;
                flex-direction: column;
            }
        }

        @media (max-width: 900px) {
            gap: clamp(20px, 4vh, 40px);
        }

        @media (max-width: 768px) {
            align-self: center;
        }
    }

    .img-section {
        max-width: min(348px, 30vw);
        flex-shrink: 0;
        align-self: flex-end;

        img {
            width: 100%;
            height: auto;
        }

        @media (max-width: 900px) {
            align-self: center;
        }
    }

    .primary-text {
        font-weight: 500;
        font-size: clamp(16px, 2vw, 20px);
        line-height: 1.4;
    }

    .secondary-text {
        font-weight: 400;
        font-size: clamp(14px, 1.5vw, 16px);
        line-height: 1.5;
        color: #575F6E;
    }

    .btn-redirect {
        align-self: flex-start;
    }
</style>
